module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('content-loader', {
    attrs: {
      "height": 80,
      "width": 1000,
      "speed": 2,
      "primaryColor": "#e7e7e7",
      "secondaryColor": "#aeaeae"
    }
  }, [_c('rect', {
    attrs: {
      "x": "12",
      "y": "39",
      "rx": "3",
      "ry": "3",
      "width": "402.6",
      "height": "23.24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "444.2",
      "y": "38",
      "rx": "3",
      "ry": "3",
      "width": "66.3",
      "height": "23.72"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "12",
      "y": "18.2",
      "rx": "0",
      "ry": "0",
      "width": "180",
      "height": "6"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d1713cc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/partials/ContentLoaderSearch.vue
// module id = 495
// module chunks = 0